import React from 'react';
import { ChevronSmallRight, type SvgIconT } from '@elliemae/ds-icons';

export const ChevronItem = (props?: SvgIconT.Props): JSX.Element => (
  <ChevronSmallRight size="m" color={['brand-primary', '800']} {...props} />
);

export default ChevronItem;
